import { ActionButton } from '@klp/design/index';
import { Tooltip } from '@klp/design/Tooltip';
import type { Theme } from '@material-ui/core';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useFormikContext } from 'formik';
import type { FormValuesType } from './FormContainer';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { ConfirmationDialog } from '@klp/design/ConfirmationDialog';

type FormContainerFieldGodkjennProps = {
    isDisabled: boolean;
    isLoading: boolean;
    setApprovalStatus: (status: string) => void;
    onSubmit: (values: FormValuesType) => void;
};

const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
});

export const FormContainerFieldGodkjenn: React.FC<
    FormContainerFieldGodkjennProps
> = ({ isDisabled, isLoading, setApprovalStatus, onSubmit }) => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, styles);
    const { values, setSubmitting } = useFormikContext<FormValuesType>();
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleDisapprove = () => {
        setApprovalStatus('false');
        setSubmitting(true);
        onSubmit(values);
        setSubmitting(false);
        setShowConfirmationDialog(false);
    };

    const handleApprove = () => {
        setApprovalStatus('true');
    };

    return (
        <div className={classes.container}>
            <Tooltip
                title={t('prosjekt.notAllowedToPerformAction')}
                hideTooltip={!isDisabled}
            >
                <div ref={anchorRef}>
                    <ActionButton
                        disabled={isDisabled}
                        isLoading={isLoading}
                        type="button"
                        actionType="cancel"
                        onClick={() => setShowConfirmationDialog(true)}
                        translation="formGenerator.disapprove"
                    />
                </div>
            </Tooltip>

            <Tooltip
                title={t('prosjekt.notAllowedToPerformAction')}
                hideTooltip={!isDisabled}
            >
                <ActionButton
                    disabled={isDisabled}
                    isLoading={isLoading}
                    type="submit"
                    actionType="save"
                    onClick={handleApprove}
                    translation="formGenerator.approve"
                />
            </Tooltip>
            <ConfirmationDialog
                anchorRef={anchorRef}
                showDialog={showConfirmationDialog}
                dialogContent={t(
                    'formGenerator.confirmDialog.confirmDisapproval',
                )}
                confirmText={t('formGenerator.confirmDialog.confirm')}
                cancelText={t('general.cancel')}
                onCancel={() => setShowConfirmationDialog(false)}
                onConfirm={handleDisapprove}
                className="withBlur"
            />
        </div>
    );
};
